export default {"src":"/_next/static/media/athome.1dc7ccb8.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};